import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class CardViewService {
    public viewTypeChangeSubject = new Subject<string>();
    viewTypeChangeEvent$ = this.viewTypeChangeSubject.asObservable();
    public viewDisplayModeChangeSubject = new Subject<string>();
    viewDisplayModeChangeEvent$ = this.viewDisplayModeChangeSubject.asObservable();
    public assigneesStatusChangeSubject = new Subject<{ stepId; statusId }>();
    public refreshCardsViewLabelsSubject = new Subject<boolean>();
    refreshCardsViewLabelsEvent$ = this.refreshCardsViewLabelsSubject.asObservable();
    currentViewDisplayMode: "Kanban" | "details" | "List" = "Kanban";
    currentViewType: string | null = null;
    settingsSectionChanged = false;
    selectedStepId: string;
    public isAllCardsDownloaded: boolean;

    setCurrentViewType(type: string | null) {
        this.currentViewType = type;
        // Emit change
        this.viewTypeChangeSubject.next(type);
    }
    setCurrentViewDisplayMode(type: "Kanban" | "details" | "List") {
        this.currentViewDisplayMode = type;
        // Emit change
        this.viewDisplayModeChangeSubject.next(type);
    }
}
